import { curryN, clone, equals } from 'ramda';
import React from 'react';
import { ajax } from 'jquery';
import autoBind from '../../modules/autoBind';
import Spinner from '../../modules/Spinner.jsx';
import logo from '../assets/logo.png';
import { validations } from 'common';

export default class Registration extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      windowWidth: window.innerWidth,
      resource: null,
      newData: {
        name: null,
        company: null,
        password: null
      }
    }
  }
  componentDidMount() {
    this.fetchConsultant(this.props.resourceUrl);
    window.addEventListener('resize', this.handleResize);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  handleResize() {
    this.setState({ windowWidth: window.innerWidth });
  }
  fetchConsultant(url) {
    ajax(url)
    .success((resource) => {
      const newData = this.state.newData;
      newData.name = resource.name;
      this.setState({ resource, newData });
    })
    .fail(() => this.setState({ resource: 'not found' }));
  }
  render() {
    return (
      <div className='container' style={{ padding: '30px 0px' }}>
        {this.getContent()}
      </div>
    );
  }
  getContent() {
    if (this.state.resource === null) {
      return <Spinner />;
    }

    if (this.state.resource === 'not found') {
      return <div>No se encontró el consultor...</div>;
    }

    return (<form style={{ marginTop: '50px' }}>
      {this.renderRow(<label>Nombre</label>, <input type='text' onChange={(e) => this.state.newData.name = e.target.value }></input>)}
      {this.renderRow(<label>Cliente</label>, <label>{this.state.resource.username}</label>)}
      {this.renderRow(<label>Empresa</label>, <input type='text' onChange={(e) => this.state.newData.company = e.target.value }></input>)}
      {this.renderRow(<label>Contraseña</label>, <input type='password'></input>)}
      {this.renderRow(<label>Confirmar contraseña</label>, <input type='password' onChange={(e) => this.state.newData.password = e.target.value }></input>)}
      <div style={{ textAlign: 'center' }}>
        <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className="btn btn-lg btn-success" onClick={this.handleConsultantDataSubmit}>Guardar</button>
      </div>
    </form>);
  }
  renderRow(left, right) {
    return (
      <div className='row' style={{ margin: '25px' }}>
        <div className='col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1'>
          {left}
        </div>
        <div className='col-xs-10 col-xs-offset-1 col-md-4 col-md-offset-1'>
          {right}
        </div>
      </div>
    );
  }
  handleConsultantDataSubmit() {
    let bad_format = false;
    $("input").each(function(index, val) {
      if($(this).val() === ""){
        alert("Faltan campos de llenar.");
        bad_format = true;
        return false;
      }
    });

    if(!bad_format && $("input:eq(2)").val() !== $("input:eq(3)").val()) { 
      alert("Las contraseñas nos coinciden.");
      bad_format = true
    }

    if (bad_format) {
      return false;
    }

    ajax({ 
      url: this.state.resource._rels.self, 
      method: 'PUT', 
      data: this.state.newData
    }).success(() => {
      window.location = '/';
    }).fail(() => {
      alert('Hubo un error al guardar las respuestas.');
    });
  }
}



// WEBPACK FOOTER //
// ./src/App/registration/Registration.jsx